/**
 * Telegram Mini App integratsiyasi. Telegram'dan tashqarida (oddiy brauzer, dev) ham ishlaydi:
 * initData bo'lmasa `dev:<id>` yuboriladi (API'da DEV_AUTH_BYPASS kerak).
 */
import {
  init, isTMA, retrieveRawInitData, retrieveLaunchParams, miniApp, viewport, backButton, hapticFeedback, themeParams, openInvoice,
} from '@telegram-apps/sdk-react';

let inTelegram = false;

export function setupTelegram() {
  try {
    if (!isTMA()) return false;
    init();
    inTelegram = true;
    if (miniApp.mountSync.isAvailable()) miniApp.mountSync();
    if (themeParams.mountSync.isAvailable()) themeParams.mountSync();
    if (viewport.mount.isAvailable()) {
      viewport.mount().then(() => { if (viewport.expand.isAvailable()) viewport.expand(); }).catch(() => {});
    }
    if (backButton.mount.isAvailable()) backButton.mount();
    if (miniApp.setHeaderColor.isAvailable()) miniApp.setHeaderColor('#F5F7FB');
    if (miniApp.setBackgroundColor.isAvailable()) miniApp.setBackgroundColor('#F5F7FB');
    if (miniApp.ready.isAvailable()) miniApp.ready();
    return true;
  } catch (e) {
    console.warn('Telegram SDK init xato (brauzer rejimi):', e);
    return false;
  }
}

export const isInTelegram = () => inTelegram;

export function getInitData(): string {
  if (inTelegram) {
    try { const raw = retrieveRawInitData(); if (raw) return raw; } catch { /* pastga */ }
  }
  let devId = localStorage.getItem('lexo.devId');
  if (!devId) { devId = String(100000 + Math.floor(Math.random() * 900000)); localStorage.setItem('lexo.devId', devId); }
  return `dev:${devId}`;
}

/** Start parametri: t.me/<bot>?startapp=… (initData) yoki bot tugmasidagi URL `?tgWebAppStartParam=…` / `?startapp=…`. */
export function getStartParam(): string | undefined {
  try { const sp = retrieveLaunchParams().tgWebAppStartParam; if (sp) return sp; } catch { /* pastga */ }
  try { const q = new URLSearchParams(location.search); return q.get('tgWebAppStartParam') || q.get('startapp') || undefined; } catch { return undefined; }
}

/** Telegram mijozi platformasi (android | ios | macos | tdesktop | weba | webk | …); Telegram'dan tashqarida — undefined. */
export function getPlatform(): string | undefined {
  try { return retrieveLaunchParams().tgWebAppPlatform; } catch { return undefined; }
}

/** Stars invoice havolasini Telegram to'lov oynasida ochish. Natija: paid | cancelled | failed | pending. */
export async function payInvoice(url: string): Promise<string> {
  if (!openInvoice.isAvailable()) throw new Error('Toʻlov bu Telegram versiyasida mavjud emas');
  return openInvoice(url, 'url');
}

export const haptic = {
  ok: () => { try { if (hapticFeedback.notificationOccurred.isAvailable()) hapticFeedback.notificationOccurred('success'); } catch {} },
  bad: () => { try { if (hapticFeedback.notificationOccurred.isAvailable()) hapticFeedback.notificationOccurred('error'); } catch {} },
  tap: () => { try { if (hapticFeedback.impactOccurred.isAvailable()) hapticFeedback.impactOccurred('light'); } catch {} },
};

/** Telegram BackButton'ni ko'rsatish; qaytish funksiyasini qaytaradi (unmount). */
export function useTelegramBack(onBack: (() => void) | null) {
  // react hook emas — oddiy helper; App ichida useEffect bilan chaqiriladi
  try {
    if (!inTelegram) return () => {};
    if (onBack) {
      if (backButton.show.isAvailable()) backButton.show();
      const off = backButton.onClick(onBack);
      return () => { off(); };
    }
    if (backButton.hide.isAvailable()) backButton.hide();
  } catch {}
  return () => {};
}
